module.exports = __webpack_public_path__ + "static/maximum-achievement-d7afa6715e19d5dab4aad0bbe4659ca8.jpg";